/* eslint-disable react/jsx-no-duplicate-props  */
/* eslint-disable no-unneeded-ternary */
import React from "react";
import { Box, Button, Typography, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import {
  AddCircleOutline as AddCircleOutlineIcon,
  RemoveCircleOutline as RemoveCircleOutlineIcon,
  WarningRounded,
} from "@material-ui/icons";
import { ErrorMessage, Field, FieldArray } from "formik";
import InputTextField from "src/components/Input/InputTextField";
import { addAlert } from "src/modules/notification";
// import AntSwitch from "components/switch/switch";
// import {  Help as HelpIcon, } from "@material-ui/icons";

const useStyle = makeStyles((theme) => ({
  input: {
    border: "2px solid #D0D5DD",
    borderRadius: "8px !important",
    backgroundColor: "white !important",
  },
  availableRangeCard: {
    boxShadow: "0px 0px 4px 0px #adadad",
    marginTop: 15,
    marginBottom: 10,
    position: "relative",
    "&::after": {
      content: `''`,
      position: "absolute",
      width: 11,
      height: 11,
      transform: "rotate(45deg)",
      top: -5,
      left: 95,
      backgroundColor: "white",
      boxShadow: "-2px -2px 2px -1px #dadada",
    },
  },
  table: {
    tableLayout: "auto",
    whiteSpace: "nowrap",
    "& th:last-child, td:last-child": {
      width: 65,
      paddingRight: theme.spacing(3),
    },
    "& th,td": {
      fontSize: "small",
      borderBottom: "0",
      padding: theme.spacing(1, 2, 1, 2),
      color: theme.palette.primary.main,
    },
    "& th": {
      borderBottom: "2px solid rgba(224, 224, 224, 1)",
      fontWeight: "bold",
    },
  },
  notAvailableRange: {
    color: "#b1b1b1 !important",
  },
  stripedRow: {
    backgroundColor: "#ececec",
  },
  balanceLabel: {
    fontSize: 13,
    display: "inline",
    marginRight: 10,
  },
  balanceValue: {
    fontSize: 13,
    fontWeight: "bold",
    display: "inline",
  },
  deleteGrid: {
    display: "flex",
    justifyContent: "center",
  },
  deleteButton: {
    border: "2px solid #E4E7EC",
    borderRadius: 4,
    color: "#98A2B3",
    height: 47,
    minWidth: 47,
    padding: 0,
  },
  addButton: {
    border: "2px solid #E4E7EC",
    borderRadius: 4,
    color: "#6AAF68",
    height: 47,
    minWidth: 47,
    padding: 0,
  },
  quantityLabel: {
    height: 47,
    alignItems: "center",
    display: "flex",
    minWidth: "80px",
    textAlign: "left",
  },
  quantityValue: {
    fontWeight: "bold",
    display: "inline",
  },
  addButtonLabel: {
    fontSize: 12,
  },
  warningError: {
    border: "1px solid #f44336",
    display: "flex",
    gap: "4px",
    padding: "9px",
    borderRadius: "10px",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: "12px",
    color: "#f44336",
  },
}));

function RenderFormikField({ name, formik, onChange, disabled, placeholder }) {
  const classes = useStyle();
  return (
    <>
      <Field name={name}>
        {({ field, form, meta }) => (
          <InputTextField
            {...field}
            hiddenLabel
            variant="filled"
            fullWidth
            type="number"
            size="small"
            disabled={disabled}
            placeholder={placeholder}
            onKeyDown={(e) => {
              const invalidChars = ["-", "+", "e", "."];
              if (invalidChars.includes(e.key)) {
                e.preventDefault();
              }
            }}
            inputProps={{
              min: 0,
            }}
            error={meta.error && meta.touched ? true : false}
            helperText={ErrorMessage({ name: field.name })}
            onChange={onChange}
            InputProps={{
              className: classes.input,
            }}
          />
        )}
      </Field>
    </>
  );
}

export default function CustomRangePanelComponent({
  formik,
  onCustomRangeChange,
  isSameRange,
  isInputDisable,
  submit,
  isSNexceedRange,
}) {
  const classes = useStyle();

  // used to check button disabled
  function isValidRange() {
    const { errors, touched, values } = formik;
    const { generateRanges } = values;

    for (let i = 0; i < generateRanges.length; i++) {
      const range = generateRanges[i];
      if (
        !errors.generateRanges?.[i]?.start &&
        !errors.generateRanges?.[i]?.end &&
        touched.generateRanges?.[i]?.start &&
        touched.generateRanges?.[i]?.end &&
        range.start != null &&
        range.end != null &&
        !Number.isNaN(range.start) &&
        !Number.isNaN(range.end) &&
        range.start !== "" &&
        range.end !== "" &&
        range.start > 0 &&
        range.end > 0
      ) {
        return true;
      }
    }
    return false;
  }

  return (
    <Box mt="10px">
      <FieldArray name="generateRanges">
        {(arrayHelper) => (
          <>
            {formik.values.generateRanges.map((range, i) => (
              <Box
                display="flex"
                mt={i === 0 ? 0 : 1}
                key={i}
                style={{ gap: "20px" }}
              >
                <Box display="flex" flex="1 1 70%">
                  <RenderFormikField
                    placeholder="Enter a digit range"
                    name={`generateRanges.${i}.start`}
                    formik={formik}
                    onChange={(e) =>
                      onCustomRangeChange(e, `generateRanges.${i}.start`, i)
                    }
                    isSameRange={isSameRange}
                    disabled={isInputDisable}
                  />
                  <Box mx={1.5} mt={1.25}>
                    <Typography>
                      <b>-</b>
                    </Typography>
                  </Box>
                  <RenderFormikField
                    placeholder="Enter a digit range"
                    name={`generateRanges.${i}.end`}
                    formik={formik}
                    onChange={(e) =>
                      onCustomRangeChange(e, `generateRanges.${i}.end`, i)
                    }
                    isSameRange={isSameRange}
                    disabled={isInputDisable}
                  />
                </Box>
                <Box
                  display="flex"
                  flex="1 1 20%"
                  style={{ wordBreak: "break-all", whiteSpace: "normal" }}
                >
                  <Typography variant="body2" className={classes.quantityLabel}>
                    Quantity:{" "}
                    {
                      // Check if there are no errors for the start and end fields before calculating quantity
                      !formik.errors.generateRanges?.[i]?.start &&
                      !formik.errors.generateRanges?.[i]?.end &&
                      formik.touched.generateRanges?.[i]?.start &&
                      formik.touched.generateRanges?.[i]?.end &&
                      range.start != null &&
                      range.end != null &&
                      !Number.isNaN(range.start) &&
                      !Number.isNaN(range.end) &&
                      range.start !== "" &&
                      range.end !== "" &&
                      range.start > 0 &&
                      range.end > 0
                        ? new Intl.NumberFormat().format(
                            range.end - range.start + 1
                          )
                        : 0
                    }
                  </Typography>
                </Box>
                <Box display="flex" flex="1 1 10%">
                  <Button
                    style={{
                      marginRight: 8,
                      opacity:
                        formik.values.generateRanges.length > 1 ? 1 : 0.5,
                    }}
                    classes={{ root: classes.deleteButton }}
                    onClick={() => {
                      if (formik.values.generateRanges.length > 1) {
                        arrayHelper.remove(i);
                      } else {
                        addAlert("Must have at least 1 range.");
                      }
                    }}
                  >
                    <RemoveCircleOutlineIcon />
                  </Button>
                  <Button
                    classes={{ root: classes.addButton }}
                    onClick={() => {
                      if (!isInputDisable) {
                        if (formik.values.generateRanges.length < 10) {
                          arrayHelper.push({
                            start: "",
                            end: "",
                          });
                        } else {
                          addAlert("Only can have maximum 10 ranges.");
                        }
                      }
                    }}
                  >
                    <AddCircleOutlineIcon />
                  </Button>
                </Box>
              </Box>
            ))}
            {(isSameRange || isSNexceedRange) && (
              <Paper elevation={0} className={classes.warningError}>
                <WarningRounded style={{ color: "#f44336" }} />
                <Typography
                  variant="body2"
                  style={{
                    color: "#f44336",
                    fontSize: "0.75rem",
                    margin: "0px",
                  }}
                >
                  {isSameRange
                    ? "Similar range already exists. Please adjust the range and try again"
                    : "The selected quantity exceeds the allowable range for the chosen pattern"}
                </Typography>
              </Paper>
            )}
          </>
        )}
      </FieldArray>
      <Box display="flex" justifyContent="flex-end" mt={1}>
        <Button
          variant="contained"
          onClick={() => submit(formik)}
          disabled={
            formik.values.generateRanges.length < 1 ||
            formik.values.generateRanges.length > 10 ||
            !isValidRange()
          }
        >
          Check Availability
        </Button>
      </Box>
    </Box>
  );
}
